export default "__VITE_ASSET__cf655d62__"